const items = (that) => [
    {
        enabled: true,
        key: 0,
        label: that?.$t("message.liveSupport"),
        icon: {
            type: "material-icons",
            name: "support_agent",
        },
    },
    {
        enabled: true,
        key: 6,
        label: that?.$t("message.teamChat"),
        counter: that?.unreadMessages,
        icon: {
            type: "material-icons",
            name: "group",
        },
    },
    {
        enabled: true,
        key: 1,
        label: that?.$t("message.siteVisitors"),
        counter: that?.liveVisitorCount,
        icon: {
            type: "material-icons",
            name: "public",
        },
    },
    {
        enabled: true,
        key: 2,
        label: that?.$t("message.conversationHistory"),
        icon: {
            type: "material-icons",
            name: "history",
        },
    },
    {
        enabled: true,
        key: 3,
        label: that?.$t("message.representative"),
        icon: {
            type: "material-icons",
            name: "engineering",
        },
    },
    {
        enabled: that?.whatsappChannelExists,
        key: 5,
        label: that?.$t("WhatsappContacts"),
        icon: {
            type: "component",
            name: "WhatsappIcon",
        },
    },
    {
        enabled: that?.instagramChannelExists,
        key: 9,
        label: that?.$t("InstagramContacts"),
        icon: {
            type: "component",
            name: "InstagramIcon",
        },
    },
    {
        enabled: that?.messengerChannelExists,
        key: 10,
        label: that?.$t("MessengerContacts"),
        icon: {
            type: "component",
            name: "MessengerIcon",
        },
    },
    {
        enabled: that?.metaLeadsChannelExists,
        key: 14,
        label: "Meta Leads",
        icon: {
            type: "component",
            name: "MetaIcon",
        },
    },
    {
        enabled: true,
        key: 8,
        label: that?.$t("message.events"),
        icon: {
            type: "material-icons",
            name: "event",
        },
    },
    {
        enabled: true,
        key: 11,
        label: that?.$t("message.reservations"),
        icon: {
            type: "material-icons",
            name: "event_available",
        },
    },
    {
        enabled: true,
        key: 7,
        label: that?.$t("notification.activities"),
        icon: {
            type: "material-icons",
            name: "rss_feed",
        },
    },
    {
        enabled: !!that?.websiteTrackingUrl,
        key: 12,
        label: "Website Analytics",
        icon: {
            type: "material-icons",
            name: "analytics",
        },
    },
    {
        enabled: true,
        key: 13,
        label: that?.$t("automation.automations"),
        icon: {
            type: "component",
            name: "atomic-power",
            class: "myIcon",
            style:{ fill: 'var(--color-icon-primary-default)' }
        },
    },
];

export default items;
